import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik } from "formik";
import * as yup from "yup";

const initialValues = {
  charges: "",
};
const onFormSubmit = async (values) => {
  
};
const validateChargesForm = yup.object().shape({
  charges: yup.number().required(" Cancelation charges is required"),
});
export default function DialogDistance({
  open,
  handleDistanceClose,
  onChangeloyality,
  updateAdvanceCharge,
  loyality_point,
}) {
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => onFormSubmit(values)}
        validationSchema={validateChargesForm}
      >
        {({ values }) => (
          <>
            <Dialog
              open={open}
              onClose={handleDistanceClose}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogTitle
                id="responsive-dialog-title"
                sx={{
                  height: "19px",
                  fontStyle: "normal",
                  fontWeight: "500",
                  fontSize: "14px",
                  lineHeight: "15px",
                  display: "flex",
                  alignItems: "center",
                  color: "#111111",
                  marginTop: "1.2rem",
                }}
              >
                {"Update Loyality Point"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <input
                    placeholder=""
                    onChange={(e) =>
                      onChangeloyality("loyality_point", e.target.value)
                    }
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^0-9]/g, "")
                        .slice(0, 3);
                    }}
                    defaultValue={loyality_point}
                    style={{
                      padding: "10px 15px",
                      width: "300px",
                      height: "25px",
                      background: "#FFFFFF",
                      border: "1px solid #EBEBEB",
                      borderRadius: "6px",
                    }}
                  ></input>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  sx={{
                    background: "#04AAD",
                    marginRight: "1rem",
                    width: "100.17px",
                    height: "40px",
                    marginBottom: "1.2rem",
                    cursor: "pointer",
                  }}
                  autoFocus
                  onClick={() => {
                    updateAdvanceCharge();
                  }}
                >
                  Save
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </Formik>
    </>
  );
}
